import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export interface StepUpState {
  isOpen: boolean;
}

export interface StepUpActions {
  prompt: () => Promise<boolean>;
  onSuccess: () => void;
  onCancel: () => void;
}

export type StepUpStore = StepUpState & StepUpActions;

type StepUpPending = Promise<boolean> | null;
type StepUpResolve = (success: boolean) => void;

const noop: StepUpResolve = () => {};

export const createStepUpStore = () => {
  let pending: StepUpPending = null;
  let resolve: StepUpResolve = noop;

  const withImmer = immer<StepUpStore>((set) => ({
    isOpen: false,
    prompt() {
      if (pending) {
        return pending;
      }
      pending = new Promise<boolean>((r) => {
        resolve = r;
        set((state) => {
          state.isOpen = true;
        });
      }).finally(() => {
        pending = null;
        resolve = noop;
      });
      return pending;
    },
    onSuccess() {
      resolve(true);
      set((state) => {
        state.isOpen = false;
      });
    },
    onCancel() {
      resolve(false);
      set((state) => {
        state.isOpen = false;
      });
    },
  }));

  return create(withImmer);
};

export const useStepUpStore = createStepUpStore();
